
import auth from "@/router/middlewares/auth"
import MainView from "@/components/layout/main-view"
import DomainCreate from "@/components/domain/domain-create"
 import DomainList from "@/components/domain/domain-list"
 import DomainDeleted from "@/components/domain/domain-deleted"
 import DomainHandles from "@/components/domain/domain-handles"
 import DomainNameserver from "@/components/domain/domain-nameserver"
 import DomainSetup from "@/components/domain/domain-setup"
 import DomainPrices from "@/components/domain/domain-prices"
import DomainDetails from "@/components/domain/domain-details"
import LumaShowHandle from "@/components/domain/handles_domain/luma-show-handle"

export default [

    {
        path:'/domain',
        name:'domain-view',
        component:MainView,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },

    {
        path:'/domain/create',
        name:'domain-create',
        component:DomainCreate,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },

    {
        path:'/domain/list',
        name:'domain-list',
        component:DomainList,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },
    {
      path:'/domain/details/:name',
      name:'domain-details',
      component:DomainDetails,
      meta:{
        middleware:auth,
        "package":'domain',
        "key":'domain'
      }
    },

    {
        path:'/domain/deleted',
        name:'domain-deleted',
        component:DomainDeleted,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },

    {
        path:'/domain/handles',
        name:'domain-handles',
        component:DomainHandles,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },
  {
    path:'/domain/handles/:handle',
    name:'domain-handle-single',
    component:LumaShowHandle,
    meta:{
      middleware:auth,
      "package":'domain',
      "key":'domain'
    }

  },

    {
        path:'/domain/nameserver',
        name:'domain-nameserver',
        component:DomainNameserver,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },

    {
        path:'/domain/setup',
        name:'domain-setup',
        component:DomainSetup,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    },

    {
        path:'/domain/prices',
        name:'domain-prices',
        component:DomainPrices,
        meta:{
            middleware:auth,
            "package":'domain',
            "key":'domain'
        }

    }
]



// WEBPACK FOOTER //
// ./src/router/routes/domain/index.js